import type { FC } from 'react';

import { AppViewer } from './components/AppViewer/AppViewer';
import { AppStoreProvider } from './store/appStore';
import { useApp } from './App.hooks';

export const App: FC = () => {
  useApp();

  return (
    <AppStoreProvider>
      <AppViewer />
    </AppStoreProvider>
  );
};
